import { css, SerializedStyles } from "@emotion/react";

import theme from "../../styles/theme";
import { greyLight } from "../../styles/variables";

const { spacing } = theme;

export const labelWrapper = (marginTop = 0): SerializedStyles => css`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: ${spacing(marginTop)}px;
  margin-bottom: ${spacing(1)}px;
`;

export const codeBlock = css`
  padding: ${spacing(2)}px;
  width: 100%;
  border: none;
  border-radius: 4px;
  background: ${greyLight};
  resize: none;
  outline: none;
`;

export const btn = css`
  min-width: unset;
`;
